import { Component, OnInit, Input } from '@angular/core';
import { TTDateAgoPipe, TTDateFormatPipe, TTDateFormatPipe2 } from 'src/app/global.pipe';
import { BatchService } from 'src/services/batch.services';

@Component({
  selector: 'rm-batch-distribution',
  templateUrl: './batch-distribution.component.html',
  styleUrls: ['./batch-distribution.component.css']
})
export class BatchDistributionComponent implements OnInit {
  @Input()
  productId: string;

  _gcp: string;
  get gcp() {
    return this._gcp;
  }

  @Input()
  set gcp(val) {
    this._gcp = val;
  }

  @Input()
  batchNum: string;

  @Input()
  gln: string;

  subscriptions: any = [];

  constructor(
    private batchService: BatchService,
    private ttdateformat: TTDateFormatPipe2
  ) { }

  google: any;
  gmap: any;

  markers: any[] = [];
  cMarkers: any[] = [];
  rMarkers: any[] = [];
  positionArr: any[] = [];

  ngOnInit() {
    this.google = window["google"];
    this.gmap = new this.google.maps.Map(
      document.getElementById("rm_map_div"),
      {
        center: { lat: 51.476852, lng: -0.0005 },
        zoom: 2,
        maxZoom: 11,
        mapId: '32c64ca2d80e5193'
      }
    );

    this.loadBatchDistribution();
  }

  addMarker(eventData) {

    var icon;
    var status = "";
    var ringIcon;
    var roleName = "";
    var lastReceivedDtm = this.ttdateformat.transform(eventData.lastReceivedDtm);
    var packages = eventData.packageData;
    var packageInfo = "";

    for (var x in packages) {
      packageInfo += '<p>' + x + ' package(s) : <b> ' + packages[x] + '</b> </p>';
    }

    if (eventData.roleName == "brand-owner") {
      status = '<p>Dispatched : <b> ' + lastReceivedDtm + '</b> </p>';
      roleName = "Brand Owner";

      icon = {
        url: './assets/images/factory2.png',
        scaledSize: new this.google.maps.Size(50, 50),
        origin: new this.google.maps.Point(0, 0),
        anchor: new this.google.maps.Point(25, 25),
      };

      ringIcon = {
        path: this.google.maps.SymbolPath.CIRCLE,
        scale: 27,
        strokeWeight: 6,
        strokeColor: '#1B61CC',
      }
    }
    if (eventData.roleName == "distributor") {
      status = '<p>Received : <b> ' + lastReceivedDtm + '</b> </p>';
      roleName = "Distributor";

      icon = {
        url: './assets/images/warehouse.png',
        scaledSize: new this.google.maps.Size(30, 30),
        origin: new this.google.maps.Point(0, 0),
        anchor: new this.google.maps.Point(15, 15),
      };

      ringIcon = {
        path: this.google.maps.SymbolPath.CIRCLE,
        scale: 16,
        strokeWeight: 6,
        strokeColor: '#1B61CC',
      };
    }
    if (eventData.roleName == "guest") {
      status = '<p>Received : <b> ' + lastReceivedDtm + '</b> </p>';
      roleName = "Guest";

      icon = {
        url: './assets/images/consumer.png',
        scaledSize: new this.google.maps.Size(30, 30),
        origin: new this.google.maps.Point(0, 0),
        anchor: new this.google.maps.Point(15, 15),
      };

      ringIcon = {
        path: this.google.maps.SymbolPath.CIRCLE,
        scale: 16,
        strokeWeight: 6,
        strokeColor: '#1B61CC',
      };
    }
    
    let contentString = '<div id="content">' +
      '<p>Name : <b> '+ eventData.userName +'</b> </p>' +  
      '<p>Role : <b> ' + roleName + '</b> </p>' +
      packageInfo +
      status + '</div>';

    //creating a new info window with markers info
    const infoWindow = new this.google.maps.InfoWindow({
      content: contentString
    });

    //Add click event to open info window on marker
    // marker.addListener("click", () => {
    //   infoWindow.open(marker.getMap(), marker);
    // });
    
    var position = new this.google.maps.LatLng({lat: parseInt(eventData.lat), lng: parseInt(eventData.lng)});
    this.positionArr.push(position);

    var marker = new this.google.maps.Marker({
      position: position,
      map: this.gmap,
      icon: icon,
      zIndex: 100
    });
    // this.markers.push(marker);

    var ringMarker = new this.google.maps.Marker({
      position: position,
      icon: ringIcon,
      map: this.gmap,
      zIndex: 10
    });
    this.rMarkers.push(ringMarker);
    
    ringMarker.bindTo("position", marker);

    marker.addListener('click', function () {
      infoWindow.open(this.gmap, marker);
    });
  }

  loadCurveMarkers(thisref) {
    var curveMarkerParams = [];
    var pLn = this.positionArr.length;

    for (var i = 0; i < pLn; i++) {
      var loc = this.positionArr[i];

      if (!(i+1 == pLn)) {
        var nextLoc = this.positionArr[i+1];
        var pos1 = loc;
        var pos2 = nextLoc;

        curveMarkerParams.push([thisref, pos1, pos2]);
      }
    }

    if (thisref.cMarkers.length > 0) {
      for (var i = 0; i < thisref.cMarkers.length; i++) {
        thisref.cMarkers[i].setMap(null);
      }
      thisref.cMarkers = [];
    }
    curveMarkerParams.forEach(element => {
      updateCurveMarker(element[0], element[1], element[2]);
    });


    this.google.maps.event.addListener(this.gmap, 'projection_changed', function() {
      for (var i = 0; i < thisref.cMarkers.length; i++) {
        thisref.cMarkers[i].setMap(null);
      }
      thisref.cMarkers = [];

      if (!thisref.showAll) {
        curveMarkerParams.forEach(element => {
          updateCurveMarker(element[0], element[1], element[2]);
        })
      }
    });
    this.google.maps.event.addListener(this.gmap, 'zoom_changed', function() {
      for (var i = 0; i < thisref.cMarkers.length; i++) {
        thisref.cMarkers[i].setMap(null);
      }
      thisref.cMarkers = [];

      if (!thisref.showAll) {
        curveMarkerParams.forEach(element => {
          updateCurveMarker(element[0], element[1], element[2]);
        })
      }
    });

    function updateCurveMarker(thisref, pos1, pos2) {
      var projection = thisref.gmap.getProjection();
      var p1 = projection.fromLatLngToPoint(pos1); // xy
      var p2 = projection.fromLatLngToPoint(pos2);
      var curvature = 0.5; // how curvy to make the arc

      // Calculate the arc.
      // To simplify the math, these points 
      // are all relative to p1:
      var e = new thisref.google.maps.Point(p2.x - p1.x, p2.y - p1.y), // endpoint (p2 relative to p1)
          m = new thisref.google.maps.Point(e.x / 2, e.y / 2), // midpoint
          o = new thisref.google.maps.Point(e.y, -e.x), // orthogonal
          c = new thisref.google.maps.Point( // curve control point
              m.x + curvature * o.x,
              m.y + curvature * o.y);

      var pathDef = 'M 0,0 ' +
        'q ' + c.x + ',' + c.y + ' ' + e.x + ',' + e.y;

      var zoom = thisref.gmap.getZoom(),
        scale = 1 / (Math.pow(2, -zoom));

      var symbol = {
        path: pathDef,
        scale: scale,
        strokeWeight: 2,
        strokeColor: '#1B61CC',
        // geodesic: true,
      };

      var curveMarker = new thisref.google.maps.Marker({
        position: pos1,
        clickable: false,
        icon: symbol,
        zIndex: 0, // behind the other markers
        map: thisref.gmap
      });

      thisref.cMarkers.push(curveMarker);
    }
  }

  loadBatchDistribution(){
    this.batchService.batchDistribution(this.batchNum).subscribe(
      (result: any) => {
        this.markers = result;

        for (var i = 0; i < this.markers.length; i++) {
          var markerInfo = this.markers[i];
          this.addMarker(markerInfo);
        }
        this.loadCurveMarkers(this);
      }
    );
  }
}
